import {
    SET_APP_CONTENT_LANGUAGE
  } from './index'

const defaultLanguage = 'no';

export const appContentLanguage = (state = defaultLanguage, action) => {
    switch (action.type) {
        case SET_APP_CONTENT_LANGUAGE:
        return action.payload
        default:
        return state
    }
}

export const getDefaultLanguage = () => {
  if (!window.localStorage) return defaultLanguage
  let language = window.localStorage.getItem('language')
  if (!language) {
    setLocalStorageLanguage(defaultLanguage)
    language = window.localStorage.getItem('language')
  }
  return language;
}

export const setLocalStorageLanguage = (language) => {
  if (!window.localStorage) return
  window.localStorage.setItem('language', language)
}
  